export default "__VITE_ASSET__3f2f2db2__"